import { Locale } from './locale';

export interface RequestData {
  pageviewId: string;
  uow: string;
  headersToForward: Record<string, string>;
  locale: Locale;
  device: DeviceInfo;
  operation_id: string;
  userData: {
    isClubeMember: boolean;
    trackerId: string;
  };
}

export interface DeviceInfo {
  type: DeviceType;
  os: DeviceOS;
  isWebView: boolean;
}

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  TABLET = 'tablet',
}

export enum DeviceOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  WINDOWS = 'Windows',
  MAC_OS = 'Mac',
  LINUX = 'Linux',
  OTHER = 'Other',
}
